<template>
<span>
    <campaign-details></campaign-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import CampaignDetails from '@/components/moduls/CampaignDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'campaign',
    components:{
        CampaignDetails,
        PageFooter
    }

    
};
</script>


